import React, { FunctionComponent, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { useSwipeable } from 'react-swipeable';
import { IBindingAction } from '../../../../common/models/callback';
import RegularButton from '../../../../components/RegularButton';
import Checkbox from '../../../../components/Checkbox';
import IconButton from '../../../../components/IconButton';
import { ReactComponent as ArrowRight } from '../../../../assets/icons/arrow-right.svg';
import { ReactComponent as ArrowLeft } from '../../../../assets/icons/arrow-left.svg';
import { IAppState } from '../../../../common/models/store/IAppState';
import { consentTexts } from './utils';
import styles from './styles.module.scss';

const link = 'https://www.kodiakhr.com/legal/terms-of-service';

interface IProps {
  defaultChecked: boolean;
  companyName: string;
  onGoBack: IBindingAction;
  onContinue: IBindingAction;
}

const ConsentWaiver: FunctionComponent<IProps> = ({
  defaultChecked,
  companyName,
  onGoBack,
  onContinue
}) => {
  const [checked, setChecked] = useState(defaultChecked);
  const swipeHandler = useSwipeable({
    onSwipedLeft: () => {
      if (checked) {
        onContinue();
      }
    },
    onSwipedRight: onGoBack,
    trackMouse: false
  });

  return (
    <div {...swipeHandler} className="cf-container">
      <div className="cf-header-title mb-2">
        <FormattedMessage {...consentTexts.header} />
      </div>
      <div className="cf-title mb-4">
        <FormattedMessage {...consentTexts.title} />
      </div>
      <div className="cf-subtitle text-left">
        <FormattedMessage
          {...consentTexts.text}
          values={{ breakingLine: <br />, customer: companyName }}
        />
        <strong><FormattedMessage {...consentTexts.textBold} values={{ customer: companyName }} /></strong>
      </div>
      <div className={styles.checkboxContainer}>
        <Checkbox
          checked={checked}
          onChange={e => setChecked(e.target.checked)}
          label={{
            ...consentTexts.checkbox,
            values: {
              link: (
                // eslint-disable-next-line react/jsx-no-target-blank
                <a target="_blank" className="link inter-font" href={link}>
                  <FormattedMessage {...consentTexts.link} />
                </a>
              )
            } }}
        />
      </div>
      <div className="cf-footer-btns">
        <IconButton
          size="lg"
          icon={<ArrowLeft />}
          onClick={onGoBack}
        />
        <RegularButton
          disabled={!checked}
          size="lg"
          textIntlId="candidateForm.next"
          defaultMessage="Next"
          icon={<ArrowRight />}
          iconPosition="right"
          onClick={onContinue}
        />
      </div>
    </div>
  );
};

const mapStateToProps = ({
  workspace: { name }
}: IAppState) => ({ companyName: name });

export default connect(mapStateToProps)(ConsentWaiver);
